import React from 'react'
import HostProfile from "../../Components/HostProfile/HostProfile"
const HostProfilePage = () => {
    return (
        <div>
            
            <HostProfile></HostProfile>
        </div>
    )
}

export default HostProfilePage
